<template>
  <i class="fa-brands fa-web-awesome wp-icon" :style="fontSize ? { fontSize } : {}" />
</template>

<script setup lang="ts">
interface Props {
  fontSize?: string
}

withDefaults(defineProps<Props>(), {
  fontSize: '1em',
})

defineOptions({ name: 'WpIcon' })
</script>

<style scoped lang="scss">
.wp-icon {
  display: inline-block;
  vertical-align: middle;
  color: #b9ea45;
  font-size: 1em;
}
</style>